import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export default function EssentialPerformanceGear() {
  return <section className="py-24 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-4">
              Essential <span className="text-primary/20">Performance</span> Gear
            </h2>
            <p className="text-muted-foreground text-lg max-w-md">
              Engineered for the elite athlete. Our latest collection of high-performance training apparel and equipment is arriving soon.
            </p>
          </div>
          <div className="flex flex-col items-end gap-2">
            <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-pink-500 bg-pink-500/10 px-2 py-1 rounded-md">
              Status: In Development
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[1, 2, 3].map((item, i) => <div key={item} data-index={i} className="group relative aspect-[4/5] bg-muted rounded-lg overflow-hidden flex items-center justify-center border border-border/50">
              <div className="text-center p-8">
                <div className="w-12 h-[1px] bg-primary/20 mx-auto mb-4" />
                <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground/50">
                  Drop 01
                </h3>
                <p className="mt-2 text-xs font-mono text-muted-foreground/30 uppercase">
                  Coming Soon
                </p>
              </div>
              <div className="absolute inset-0 bg-linear-to-t from-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button variant="outline" className="rounded-md border-primary px-8 py-6 uppercase text-xs font-bold tracking-widest hover:bg-primary hover:text-primary-foreground transition-all duration-300">
            Notify Me On Release
          </Button>
        </div>
      </div>
    </section>;
}